class DateService {
    public static toUIDate(unformattedDate: string) {
        const date = new Date(unformattedDate);
        return date.toLocaleString();
    }
}

export default DateService;
